import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import CtaBand from "@/components/home/CtaBand";
import { ARTICLES } from "@/data/articles";

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <section className="pt-36 sm:pt-44 pb-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <Eyebrow>Resources</Eyebrow>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-ink leading-[1.05] max-w-3xl">
              Finance, <span className="font-editorial italic font-medium text-gold-600">explained plainly.</span>
            </h1>
            <p className="mt-8 text-base sm:text-lg text-ink/60 max-w-2xl leading-relaxed">
              Practical guides on commercial property, practice and acquisition finance — written from decades on both
              sides of the credit table.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 sm:pb-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {ARTICLES.map((a, i) => (
              <Reveal key={a.slug} delay={0.05 * (i % 3)}>
                <Link
                  to={`/resources/${a.slug}`}
                  data-testid={`article-card-${a.slug}`}
                  className="group flex flex-col h-full rounded-3xl bg-white border border-ink/8 p-8 transition-all duration-500 hover:-translate-y-2 hover:border-gold/60 hover:shadow-lift"
                >
                  <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-gold-700">{a.category}</span>
                  <h2 className="font-display text-xl font-bold text-ink mt-3 mb-3 leading-snug">{a.title}</h2>
                  <p className="text-sm text-ink/55 leading-relaxed flex-1">{a.excerpt}</p>
                  <div className="flex items-center justify-between mt-7 pt-5 border-t border-ink/8">
                    <span className="text-[11px] text-ink/40 flex items-center gap-1.5">
                      <Clock size={12} /> {a.read}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-ink/40 group-hover:text-gold-600 transition-colors">
                      Read <ArrowUpRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </div>
  );
}
